import qs from 'qs'
import { CardFilter, CreateCardDto, UpdateCardDto } from '../models'
import axiosClient from './axiosClient'

const PATH = '/cards'

export const cardApi = {
  getCards: (filter: CardFilter) =>
    axiosClient.get(PATH, {
      params: filter,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  getCardById: (id: string) =>
    axiosClient.get(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  updateCard: (id: string, createCardDto?: CreateCardDto) =>
    axiosClient.put(
      `${PATH}/${id}`,
      { ...createCardDto },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    ),

  createCard: (updateCard?: UpdateCardDto) =>
    axiosClient.post(
      PATH,
      { ...updateCard },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    ),

  deleteCard: (id: string) =>
    axiosClient.delete(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  payInCard: (id: string, payInAmount: number) =>
    axiosClient.put(
      `${PATH}/${id}`,
      { payInAmount },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    ),
}
